import style from "../../assets/scss/sub/articleTitle.module.scss";

export function ArticleTitle({title, className}) {
  return <div className={`${style.title} ${className ?? ''}`}>
    {title}
  </div>;
}